/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : COMMENT MANAGER : STYLES --------------- ++++++++++ */
export default theme => ({
    commentmanager: {
        '& .title':{
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
            '& h2':{
                fontSize: pxToEm(24),
                fontWeight: 'bold',
                marginBottom: pxToEm(15)
            }
        },
        '& .name-commentingcontrols': {
            position: 'relative',
            zIndex: '2',
            marginBottom: pxToEm(56),
            justifyContent: 'space-between',
            flexWrap: 'inherit',
            '& .name-controls_test_page':{
                alignItems: 'center',
                '& .controls': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    '& .control': {
                        fontSize: pxToEm(14),
                        '&:last-child': {
                            marginRight: pxToEm(16)
                        }

                    }
                },
                '& .button': {
                    width: pxToEm(124),
                    height: pxToEm(40),
                    marginRight: pxToEm(20)
                },
            },
            '& .name-sites': {
                display: 'flex',
                alignItems: 'center',
                '& .fieldlabel': {
                    fontSize: pxToEm(14),
                    fontWeight: '500',
                    marginRight: pxToEm(15)
                }
            }
        },
        ...buttonStyles
    },
    [mediaQuery.medium]:{
        commentmanager: {

        }
    }
});
